import BaseComponent from "../../baseComponent.js";

export default class LineChartRealtime extends BaseComponent {
  componentWillUnmount() {
    $('#awh-chart-container').find("div[data-vol]").remove();
    clearInterval(this.dataInterval);
    clearInterval(this.transitionInterval);
    for (var i = 0; i < this.timeouts.length; i++) {
      clearTimeout(this.timeouts[i]);
    }
  }

  startUpdate(data, chart, callback) {
    var count = 0;
    this.dataInterval = setInterval(function () {
      var dataPoint = data.next();

      var rand = Math.floor(Math.random() * 9) + 1;
      var color = "#75a641";

      if (rand % 3 === 1) {
        color = "#ff9900";
      }

      if (dataPoint[0].y === 1.24674) {
        callback(80, "2M", 40, 14, -50, color);
      } else if (dataPoint[0].y === 1.246735) {
        callback(307, "4M", 45, 16, 0, color);
      } else if (dataPoint[0].y === 1.246736) {
        callback(255, "12M", 60, 19, 0, color);
      } else if (dataPoint[0].y === 1.246742) {
        callback(-18, "20M", 70, 20, 0, color);
      } else if (dataPoint[0].y === 1.246734) {
        callback(336, "50M", 80, 24, 0, color);
      } else if (dataPoint[0].y === 1.246739) {
        callback(120, "8M", 55, 18, -200, color);
      }

      chart.push(dataPoint);
    }, 1100);
  }

  stopUpdate() {
    clearInterval(this.dataInterval);
  }

  componentDidMount() {
    var that = this;
    var demoData = [
      1.246734,
      1.246735,
      1.246735,
      1.246735,
      1.246735,
      1.246735,
      1.246736,
      1.246737,
      1.246738,
      1.246739,
      1.24674,
      1.24674,
      1.24674,
      1.24674,
      1.24674,
      1.24674,
      1.24674,
      1.246741,
      1.246742,
      1.246742,
      1.246742,
      1.246742,
      1.246739,
      1.246738,
      1.246737,
      1.246736,
      1.246736,
      1.246736,
      1.246736,
      1.246735,
      1.246734,
      1.246735,
      1.246735,
      1.246735,
      1.246735,
      1.246736,
      1.246736,
      1.246736,
      1.246737,
      1.246737,
      1.246737,
      1.246737,
      1.246737,
      1.246737,
      1.246737,
      1.246738,
      1.246739,
      1.246740,
      1.246741,
      1.246742,
      1.246742,
      1.246742,
      1.246742,
      1.246742,
      1.246742,
      1.246742,
      1.246741,
      1.246741,
      1.246741,
      1.246741,
      1.246741,
      1.246741,
      1.2467400,
      1.2467380,
      1.2467360,
      1.2467360,
      1.2467360,
      1.2467360,
      1.2467360,
      1.2467360,
      1.2467360,
      1.2467340,
      1.2467340,
      1.2467340,
      1.2467340,
      1.2467340,
      1.2467340,
      1.2467340,
      1.2467340
    ];
    var dataIndex = 0;
    this.timeouts = [];
    this.intervalAfterTransitionEnds = null;

    var RealTimeData = function (layers) {
      this.layers = layers;
      this.timestamp = ((new Date()).getTime() / 1000) | 0;
    };

    RealTimeData.prototype.rand = function () {
      var value = demoData[dataIndex++];
      if (dataIndex === demoData.length) {
        dataIndex = 0;
      }
      return value;
    };

    RealTimeData.prototype.history = function (entries) {
      if (typeof(entries) != 'number' || !entries) {
        entries = 40;
      }

      var history = [];
      for (var k = 0; k < this.layers; k++) {
        history.push({label: "DataSeries0", values: []});
      }

      for (var i = 0; i < entries; i++) {
        for (var j = 0; j < this.layers; j++) {
          history[j].values.push({time: this.timestamp, y: this.rand()});
        }
        this.timestamp++;
      }

      return history;
    };

    RealTimeData.prototype.next = function () {
      var entry = [];
      for (var i = 0; i < this.layers; i++) {
        entry.push({time: this.timestamp, y: this.rand()});
      }
      this.timestamp++;
      return entry;
    };

    window.RealTimeData = RealTimeData;

    var data = new RealTimeData(1);
    var chart = $('#awh-chart').epoch({
      type: 'time.line',
      data: data.history(),
      margins: {left: 70},
      axes: ['bottom', 'left'],
      tickFormats: {
        left: function (d) {
          var multiplier = Math.pow(10, 10);
          return (Math.round(d * multiplier) / multiplier);
        }
      },
      queueSize: 1,
      historySize: 40,
      windowSize: 40,
      getSnapshotData: function () {
      },
      onChartSlide: function () {
      },
      onChartZoom: function () {
      },
      isDemoChart: true,
      getWidgetLegends: function () {
        return [
          {

            "parameters": {
              "groupId": 0,
              "legendLabel": "USD/CAD SPOT",
              "legendColor": "#ff7f0e",
              "chartTypeParameters": {
                "fillOpacity": 1,
                "strokeOpacity": 1
              },
              "chartType": "line",
              "isActive": true,
              "yAxisSide": "left"
            }
          }
        ]
      }
    });

    this.startUpdate(data, chart, showDot);
    chart.push(data.next());
    var hoverTimeout = null;
    var animationShouldResume = false, onHover = false;
    var isAnimating = false;

    // 36
    function showDot(top, volume, size, fontSize, time, color) {

      var containerStyle = {
        position: "absolute",
        zIndex: "1000",
        top: top,
        left: "1180px",
        height: size,
        width: size,
        cursor: "pointer"
      };

      var pulseRingStyle = {
        border: "3px solid " + color,
        position: "absolute",
        top: 0,
        borderRadius: "80px",
        opacity: 0,
        height: size,
        width: size,
        animation: "spot-pulsate2 1.2s ease-out",
        animationIterationCount: "infinite",
        display: "none"
      };

      var timeout1 = setTimeout(function () {
        if ($('#awh-chart-container').find("div[data-vol='" + volume + "']").length > 0) return;
        var container = $("<div data-vol='" + volume + "'></div>");
        var circle = $("<div class='circle'></div>");
        var pulseRing = $("<div class='pulse-ring'></div>");
        var text = $("<span class='content'>" + volume + "</span>");
        container.css(containerStyle);

        circle.css({
          height: size,
          width: size,
          lineHeight: size + "px",
          backgroundColor: color
        });
        pulseRing.css(pulseRingStyle);
        text.css({fontSize: fontSize});


        container.append(circle).append(pulseRing);
        circle.append(text);
        $("#awh-chart-container").append(container);

        container.animate({left: 70}, 61800, "linear", function () {
          circle.css("transform", "scale(0.1)");
          container.animate({left: 35, opacity: 0}, 1260, "linear", function () {
            container.remove();
          });
        });
        isAnimating = true;

        setTimeout(function () {
          circle.css("transform", "scale(1)");
        }, 10);

        container.on("click", function () {
          var vol = $(this).attr("data-vol");
          that.props.onOrderClick(vol);
        });

        // when hover, stop providing data to epoch
        // when epoch rendering ends, stop all animations
        container.hover(function () {
          $(this).find("div.pulse-ring").show(0);
          onHover = true;
          that.stopUpdate();
        }, function () {
          onHover = false;
          that.startUpdate(data, chart, showDot);
          $(this).find("div.pulse-ring").hide(0);
        });
      }, 1900 + time);

      that.timeouts.push(timeout1);
    }


    this.transitionInterval = setInterval(function () {
      // wait until epoch rendering ends
      if (chart.inTransition() && animationShouldResume) {
        var containers = $('#awh-chart-container').find("div[data-vol]");
        for (var i = 0; i < containers.length; i++) {
          var target = $(containers[i]);
          var left = parseInt(target.css("left").replace("px", ""));

          target.animate({left: 70}, left * 52, "linear", function () {
            $(this).find("div.circle").css("transform", "scale(0.1)");
            $(this).animate({left: 35, opacity: 0}, 1260, "linear", function () {
              $(this).remove();
            });
          });
        }
        animationShouldResume = false;
      } else if (!chart.inTransition()) {
        if (isAnimating) {
          var containers = $('#awh-chart-container').find("div[data-vol]");
          for (var i = 0; i < containers.length; i++) {
            $(containers[i]).stop(true);
          }
          animationShouldResume = true;
        }
      }
    }, 100);
  }

  render() {
    var style = {
      height: "400px",

      width: "1200px",

      position: "absolute",
      left: "50%",
      marginLeft: "-600px",
      top: "200px"
    };
    var style2 = {
      height: "100%"
    };
    var titleStyle = {
      fontSize: "24px",
      position: "absolute",
      top: "-50px"
    };

    var legendStyle = {
      position: "absolute",
      bottom: "-50px",
      left: "50%",
      width: "300px",
      marginLeft: "-100px",
      display: "flex",
      flexDirection: "row"
    };

    var legend = {
      display: "inline-block",
      fontSize: "17px",
      padding: "4px 0",
      position: "relative",
      width: "100px",
      display: "flex",
      alignItems: "center"
    };
    return (
      <div id="awh-chart-container" style={style}>
        <div style={titleStyle}>USD/CAD SPOT Order Flow</div>
        <div style={legendStyle}>
          <div style={legend}>
            <div style={{
              backgroundColor: "rgb(117, 166, 65)",
              width: 14,
              height: 14,
              borderRadius: "14px",
              float: "left"
            }}></div>
            <span style={{paddingLeft: "10px"}}>Sell</span>
          </div>
          <div style={legend}>
            <div style={{
              backgroundColor: "rgb(255, 153, 0)",
              width: 14,
              height: 14,
              borderRadius: "14px",
              float: "left"
            }}></div>
            <span style={{paddingLeft: "10px"}}>Buy</span>
          </div>
        </div>
        <div id="awh-chart" className="epoch category10" style={style2}>
        </div>
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/components/dashboard/auto-hedging-widget/lineChartRealtime.jsx